export default {
  openAddToTestCycleDialog(testCaseIds: Array<number>): void {
    window.AP.dialog.create({
      key: 'add-to-test-cycle-dialog',
      size: 'maximum',
      chrome: false,
      customData: {
        testCaseIds,
      },
    });
  },
};
